import { toast } from "react-toastify";
import {
  approvalVerificationApi,
  checkexistingulrnoApi,
  InternalCertificateCreateApi,
  InternalCertificateGetApi,
  InternalCertificateUpdateApi,
} from "../../../services/api";
import {
  GetTenantDetails,
  postDataFromApi,
  putDataFromApi,
} from "../../../services/commonServices";
import { getCurrentRole, getUserDetails } from "../../../services/commonFunction";
import { handleCommonUndoLastChanges } from "./UndoApprovalRequestHandler";
import { decryptDataForURL } from "../../../utills/useCryptoUtils";
import { getScopenonscopeCount } from "./testMemoFunctionHandler";
import moment from "moment";

export const handleIntarnalCertificateValidate = async (
  handleSubmit,
  setIsPopupOpen,
  setJRFCreationType,
  type
) => {
  if (["post", "save"].includes(type)) {
    let isValidate = handleSubmit();
    if (!isValidate) {
      return false;
    }
  }

  setIsPopupOpen(true);
  setJRFCreationType(type);
};
export const handleIntarnalCertificateCreateUpdate = async (
  formData,
  testMemoId,
  navigate,
  type,
  setIsOverlayLoader,
  subTableData,
  user,
  setIsPopupOpen,
  isNoNavigate,
  callbackFunc
) => {
  let payload;
  const ic_cert_config_data = [];
  formData[0]?.param_details_combined?.forEach((singleParam, paramIndex) => {
    singleParam.basis?.map((basis, basisIndex) => {
      ic_cert_config_data.push({
        ...singleParam,
        ...basis,
        basis: [basis],
        is_display: formData[0]?.['rpc_is_avg_' + paramIndex + '_' + basisIndex] === "yes" ? true : false
      })
    })
  })
  payload = {
    ic_data: {
      ic_ulrno: formData[0]["ic_ulrno"],
      ic_refenence: formData[0]["ic_refenence"],
      ic_discipline: formData[0]["ic_discipline"],
      ic_group: formData[0]["ic_group"],
      ic_customername: formData[0]["ic_customername"],
      ic_customeraddress: formData[0]["ic_customeraddress"],
      ic_smpldrawnbylab:
        formData[0]["ic_smpldrawnbylab"] == "Sample Drawn By Laboratory"
          ? true
          : false,
      ic_is_client_req: !["Sample Drawn By Laboratory", "Sample Not Drawn By Laboratory"].includes(formData[0]["ic_smpldrawnbylab"])
        ? true
        : false,
      ic_descofsmpl: formData[0]["ic_descofsmpl"],
      ic_locationofsmpl: formData[0]["ic_locationofsmpl"],
      ic_dos: formData[0]["ic_dos"] === "N/A" ? null : formData[0]["ic_dos"],
      // ic_samplingmethods:
      //   formData[0]["ic_smpldrawnbylab"] == "Sample Drawn By Laboratory"
      //     ? formData[0]["ic_samplingmethods"]
      //       ? formData[0]["ic_samplingmethods"]
      //       : ""
      //     : formData[0]["ic_samplingmethods"],
      ic_samplingmethods: formData[0]["ic_samplingmethods"],
      ic_envcondition: formData[0]["ic_envcondition"],
      ic_mark_from: formData[0]["ic_mark_from"],
      ic_mark_to: formData[0]["ic_mark_to"],
      ic_seal_from: formData[0]["ic_seal_from"],
      ic_seal_to: formData[0]["ic_seal_to"],
      ic_conditionofsmpl: formData[0]["ic_conditionofsmpl"],
      ic_dateofrecsmpl: formData[0]["ic_dateofrecsmpl"],
      ic_dateofanalysis: formData[0]["ic_dateofanalysis"],
      ic_noofsmpls: formData[0]["ic_noofsmpls"],
      ic_ambienttemp: formData[0]["ic_ambienttemp"],
      ic_humidity: formData[0]["ic_humidity"],
      ic_borometric_pressure: formData[0]["ic_borometric_pressure"],
      ic_remarks: formData[0]["ic_remarks"],
      ic_is_mark: formData[0]["ic_is_mark"] ? true : false,
      ic_is_seal: formData[0]["ic_is_seal"] ? true : false,
      ic_dateanalysiscompleted: formData[0].ic_dateanalysiscompleted,
      ic_reference_date: formData[0].ic_reference_date,
      ic_test_performed_at: formData[0].ic_test_performed_at,
      ic_is_dos: formData[0]["ic_is_dos"] ? true : false,
      ic_is_samplingmethods: formData[0]["ic_is_samplingmethods"] ? true : false,
      ic_is_locationofsmpl: formData[0]["ic_is_locationofsmpl"] ? true : false,
      ic_is_envcondition: formData[0]["ic_is_envcondition"] ? true : false,
      ic_is_conditionofsmpl: formData[0]["ic_is_conditionofsmpl"] ? true : false,
      ic_mark_and_seal_qualifier: formData[0]["ic_mark_and_seal_qualifier"],
      ic_test_report_no: formData[0]["ic_test_report_no"],
      ic_is_2sign_format: formData[0]["ic_is_2sign_format"] || false,
      ic_as_per_client_name: formData[0]?.ic_as_per_client_name,
      ic_lab_address: formData[0]["ic_lab_address"],
      ic_as_per_client_name: formData[0]["ic_as_per_client_name"],
      tenant: GetTenantDetails(1),
      ic_is_size_analysis:
        (formData[0].ic_is_size_analysis &&
          formData[0].ic_is_size_analysis[0]) ||
        false,
      ic_size_analysis_data: subTableData,
      ic_is_account_of:
        formData[0]["ic_is_account_of"] == "Yes"
          ? true
          : false,
      ic_cert_config_data: ic_cert_config_data,
      ic_is_cert_config_data:
        (formData[0].ic_is_cert_config_data &&
          formData[0].ic_is_cert_config_data[0]) ||
        false,
    },
  };
  if (type == "post") {
    payload["ic_data"].status = "pending";
    if (!user?.logged_in_user_info?.lab_or_branch?.lab_is_compliant &&
      user?.logged_in_user_info?.lab_or_branch?.lab_is_skip_process) {
      payload["ic_data"].status = "publish";
    }
    else if (user?.all_roles?.main_role_id && user?.all_roles?.other_roles?.length) {
      payload["ic_data"].status = "dtm-approved";
    }
  }
  setIsOverlayLoader(true);
  let res;
  if (['SU'].includes(getCurrentRole())) {
    delete payload["ic_data"].status
    payload["ic_data"].is_regenerate = true;
    payload["ic_data"].change_log_remark = formData[0]["change_log_remark"];
  }
  if (formData[0].ic_id) {
    payload.ic_id = formData[0].ic_id;
    res = await putDataFromApi(InternalCertificateUpdateApi, payload);
  } else {
    if (type == "post") {
      payload["ic_data"].status = "pending";
      if (!user?.logged_in_user_info?.lab_or_branch?.lab_is_compliant &&
        user?.logged_in_user_info?.lab_or_branch?.lab_is_skip_process) {
        payload["ic_data"].status = "publish";
      }
      else if (user?.all_roles?.main_role_id && user?.all_roles?.other_roles?.length) {
        payload["ic_data"].status = "dtm-approved";
      }
    } else {
      payload["ic_data"].status = "saved";
    }

    if (['SU'].includes(getCurrentRole())) {
      delete payload["ic_data"].status
    }
    payload.test_memo_id = testMemoId;
    res = await postDataFromApi(InternalCertificateCreateApi, payload);
  }

  if (res.data && res.data.status === 200) {
    if (type == "post") {
      setIsPopupOpen(false)
      handleCommonUndoLastChanges(res?.data?.message, res?.data?.data?.ic_id, setIsOverlayLoader, navigate, "internal_certificate", formData)
    }
    else {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      if (isNoNavigate) {
        callbackFunc()
      }
      else {
        setTimeout(() => {
          navigate("/testReport");
        }, 1000);
      }
    }
  } else {
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  setIsOverlayLoader(false);
};

export const getCertificateDetailsById = async (
  id,
  setTabOpen,
  setFormData,
  setTestMemoId,
  isPreview,
  setViewOnly,
  getAssignmentMasterData,
  setIsValideValue,
  setSubTableData
) => {
  try {
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const is_amendment = decryptDataForURL(params.get("is_amendment"))
    const bodyToPass = {
      ic_id: id,
    };
    let res = await postDataFromApi(InternalCertificateGetApi, bodyToPass);
    if (res?.data?.status === 200) {
      let responseData = res.data.data;
      if (is_amendment) {
        responseData = {
          ...responseData,
          main_status: responseData?.status
        }
        responseData = {
          ...responseData,
          ...responseData.ic_amendent_data_json,
        }
        if (!responseData?.ic_amendent_data_json?.is_testreport_completed) {
          await getScopenonscopeCount(responseData.fk_tmid, null, setIsValideValue, getUserDetails(), 1, (nonScopeData = false) => {
            responseData = {
              ...responseData,
              nonScopeData: nonScopeData
            }
          }, responseData)
        }
      }
      else {
        if (['SU'].includes(getCurrentRole())) {
          await getScopenonscopeCount(responseData.fk_tmid, null, setIsValideValue, getUserDetails(), 1, (nonScopeData = false) => {
            responseData = {
              ...responseData,
              nonScopeData: nonScopeData
            }
          }, responseData)
        }
      }
      if (!isPreview) {
        if (responseData.status === "tm-approved") {
          setViewOnly(true);
        }
      }
      setTestMemoId(responseData.fk_tmid);
      responseData.ic_smpldrawnbylab = responseData.ic_smpldrawnbylab
        ? "Sample Drawn By Laboratory"
        : responseData.ic_is_client_req ? "As Per Client" : "Sample Not Drawn By Laboratory";
      responseData.ic_dos = responseData.ic_dos ? responseData.ic_dos : "N/A";
      responseData.ic_ambienttemp = responseData.ic_ambienttemp
        ? responseData.ic_ambienttemp.replace(
          new RegExp(`\\s*°C\\s*`, "gi"),
          ""
        )
        : "";
      responseData.ic_humidity = responseData.ic_humidity
        ? responseData.ic_humidity.replace(new RegExp(`\\s*%\\s*`, "gi"), "")
        : "";
      responseData.ic_borometric_pressure = responseData.ic_borometric_pressure
        ? responseData.ic_borometric_pressure.replace(
          new RegExp(`\\s*hPa\\s*`, "gi"),
          ""
        )
        : "";
      responseData.ic_rejection_remark = responseData.ic_rejection_remark
        ? responseData.ic_rejection_remark
        : "-";

      responseData.company_code = responseData.company.company_code;
      responseData.cmd_id = responseData.commodity.commodity_id;
      responseData.lab_id = responseData.fk_lab_id;
      responseData.ic_is_size_analysis = Array.isArray(responseData.ic_is_size_analysis) ? responseData.ic_is_size_analysis : responseData.ic_is_size_analysis ? [responseData.ic_is_size_analysis] : [];
      responseData.ic_is_cert_config_data = Array.isArray(responseData.ic_is_cert_config_data) ? responseData.ic_is_cert_config_data : responseData.ic_is_cert_config_data ? [responseData.ic_is_cert_config_data] : [];
      responseData.ic_is_account_of = responseData.ic_is_account_of ? "Yes" : "No";
      responseData.ic_customername_2 = responseData.ic_customername
      responseData.ic_customeraddress_2 = responseData.ic_customeraddress
      if (isPreview) {
        // responseData.company.company_code="L"
        setFormData(responseData);
      } else {
        if (setSubTableData && responseData.ic_size_analysis_data && responseData.ic_is_size_analysis?.[0]) {
          responseData.ic_size_analysis_data.map((singleData, index) => {
            responseData["sa_sample_id_" + index] = singleData["sa_sample_id"];
            responseData["param_name_" + index] = singleData["param_name"];
            responseData["param_value_" + index] = singleData["param_value"];
            responseData["param_unit_" + index] = singleData["param_unit"];
            responseData["param_method_" + index] = singleData["param_method"];
          });
          setTimeout(() => {
            setSubTableData(responseData.ic_size_analysis_data);
          }, 1000)
        }
        if (setIsValideValue) {
          setIsValideValue(true);
        }
        setFormData((prevFormData) => {
          return {
            ...prevFormData,
            0: responseData,
            1: responseData,
          };
        });
        if (responseData.ic_smpldrawnbylab) {
          getAssignmentMasterData(
            responseData.commodity.commodity_id,
            responseData.fk_lab_id,
            "parameter",
            "",
            "",
            "",
            responseData.fk_sub_commodity
          );
        }

      }
    }
  } catch (error) { console.log('errr', error) }
};

export const changeTestReportStatusChange = async (
  ic_id,
  navigate,
  status,
  remarkText = "",
  noRedirect = 0,
  getAllListingData,
  setIsPopupOpen,
  setIsOverlayLoader,
  formData,
  is_amendment
) => {
  if (is_amendment) {
    changeTestReportAmendentStatusChange(
      ic_id,
      navigate,
      status,
      remarkText,
      setIsOverlayLoader,
      formData
    )
    return
  }
  let ic_data = {
    status: status,
    tenant: GetTenantDetails(1),
  };
  if (['dtm-reject', 'tm-reject'].includes(status)) {
    status = "tm-reject";
  }
  if (status === "dtm-reject" || status === "tm-reject") {
    ic_data.ic_rejection_remark = remarkText;
  }
  let bodyToPass = {
    ic_id: ic_id,
    ic_data: ic_data,
  };
  setIsOverlayLoader(true);
  let res = await putDataFromApi(InternalCertificateUpdateApi, bodyToPass);
  if (res?.data?.status === 200) {
    if (["dtm-approved", "tm-approved"].includes(status)) {
      handleCommonUndoLastChanges(res?.data?.message, formData[0]?.ic_id, setIsOverlayLoader, navigate, "internal_certificate", formData)
    }
    else {
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      if (!noRedirect) {
        setTimeout(() => {
          navigate("/testReport");
        }, 1000);
      } else {
        setIsPopupOpen(false);
        getAllListingData();
      }
    }
  } else {
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  setIsOverlayLoader(false);
};
export const checkICULRNoAvailibility = async (
  value,
  setIsOverlayLoader,
  setIsValideValue,
  is_amendment,
  formData
) => {
  let labcode = getUserDetails()?.logged_in_user_info?.lab_or_branch?.lab_code
  let isLeavePatternCheck = false
  if (['SU'].includes(getCurrentRole())) {
    labcode = formData[0]?.lab_detail?.lab_code
    if (value === formData[1]?.ic_ulrno) {
      isLeavePatternCheck = true
    }
  }
  const regex = ['12TLGUG', '11TCMAM'].includes(
    labcode
  )
    ? /^[A-Z]+\d{4}[A-Z]{2}\d{5}(\d{10})?[A-Z]?$/
    : /^[A-Z]{2}\d{4,5}\d{2}\d{9}F?$/;
  const trimmedValue = value.trim();

  if (!regex.test(trimmedValue) && !isLeavePatternCheck) {
    setIsValideValue(false);
    return;
  }
  let payload = {
    ic_ulrno: value,
    is_amendment: is_amendment ? true : false,
    ic_id: formData[0]?.ic_id
  };
  setIsOverlayLoader(true);
  let res = await postDataFromApi(checkexistingulrnoApi, payload);
  if (res?.data?.status === 200) {
    setIsValideValue(true);
    toast.success(res.data?.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  } else {
    setIsValideValue(false);
    toast.error(res.message, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
  setIsOverlayLoader(false);
};


export const handleSendVerifictionCodeForApprovel = async (action, certiId, verificationCode, setIsOverlayLoader, confirmHandlerFunction) => {
  try {
    let payload = {
      "action": action,
      "certificate_number": certiId,
      "approver_emp_id": getUserDetails()?.all_roles?.usr_emp_id_orig || getUserDetails()?.all_roles?.usr_id
    }
    if (action === "verify") {
      payload.otp = verificationCode
    }
    setIsOverlayLoader(true);
    let res = await postDataFromApi(approvalVerificationApi, payload);
    if (res?.data?.status === 200) {
      toast.success(res.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      if (action === "verify") {
        confirmHandlerFunction()
      }
      else {
        confirmHandlerFunction(true)
      }

    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }

  }
  finally {
    setIsOverlayLoader(false);
  }
}

export const handleAmenIntarnalCertificateCreateUpdate = async (
  handleSubmit,
  formData,
  navigate,
  type,
  setIsOverlayLoader,
  subTableData,
) => {
  let isValidate = handleSubmit();
  if (!isValidate) {
    return false;
  }
  const user = getUserDetails()
  const data = formData[0];

  const ic_cert_config_data = [];

  data?.param_details_combined?.forEach((param, paramIndex) => {
    param.basis?.forEach((basis, basisIndex) => {
      ic_cert_config_data.push({
        ...param,
        ...basis,
        basis: [basis],
        is_display:
          data[`rpc_is_avg_${paramIndex}_${basisIndex}`] === "yes",
      });
    });
  });

  // Status
  let status = type === "post" ? "pending" : "saved";
  let mainStatus = type === "post" ? "amendment in-process" : "amendment saved";

  if (type === "post") {
    if (
      !user?.logged_in_user_info?.lab_or_branch?.lab_is_compliant &&
      user?.logged_in_user_info?.lab_or_branch?.lab_is_skip_process
    ) {
      status = "publish";
    } else if (
      user?.all_roles?.main_role_id &&
      user?.all_roles?.other_roles?.length
    ) {
      status = "dtm-approved";
    }
  }
  if (['SU'].includes(getCurrentRole())) {
    status = formData[0]?.ic_amendent_data_json?.status
  }
  const payload = {
    ic_data: {
      ic_ulrno: data.ic_ulrno,
      ic_refenence: data.ic_refenence,
      ic_discipline: data.ic_discipline,
      ic_group: data.ic_group,
      ic_customername: data.ic_customername,
      ic_customeraddress: data.ic_customeraddress,

      ic_smpldrawnbylab:
        data.ic_smpldrawnbylab === "Sample Drawn By Laboratory",

      ic_is_client_req: ![
        "Sample Drawn By Laboratory",
        "Sample Not Drawn By Laboratory",
      ].includes(data.ic_smpldrawnbylab),

      ic_descofsmpl: data.ic_descofsmpl,
      ic_locationofsmpl: data.ic_locationofsmpl,
      ic_dos: data.ic_dos === "N/A" ? null : data.ic_dos,
      ic_samplingmethods: data.ic_samplingmethods,
      ic_envcondition: data.ic_envcondition,
      ic_mark_from: data.ic_mark_from,
      ic_mark_to: data.ic_mark_to,
      ic_seal_from: data.ic_seal_from,
      ic_seal_to: data.ic_seal_to,
      ic_conditionofsmpl: data.ic_conditionofsmpl,
      ic_dateofrecsmpl: data.ic_dateofrecsmpl,
      ic_dateofanalysis: data.ic_dateofanalysis,
      ic_noofsmpls: data.ic_noofsmpls,
      ic_ambienttemp: data.ic_ambienttemp,
      ic_humidity: data.ic_humidity,
      ic_borometric_pressure: data.ic_borometric_pressure,
      ic_remarks: data.ic_remarks,

      ic_is_mark: !!data.ic_is_mark,
      ic_is_seal: !!data.ic_is_seal,
      ic_dateanalysiscompleted: data.ic_dateanalysiscompleted,
      ic_reference_date: data.ic_reference_date,
      ic_test_performed_at: data.ic_test_performed_at,

      ic_is_dos: !!data.ic_is_dos,
      ic_is_samplingmethods: !!data.ic_is_samplingmethods,
      ic_is_locationofsmpl: !!data.ic_is_locationofsmpl,
      ic_is_envcondition: !!data.ic_is_envcondition,
      ic_is_conditionofsmpl: !!data.ic_is_conditionofsmpl,

      ic_mark_and_seal_qualifier: data.ic_mark_and_seal_qualifier,
      ic_test_report_no: data.ic_test_report_no,
      ic_is_2sign_format: data.ic_is_2sign_format || false,
      ic_lab_address: data.ic_lab_address,
      ic_amendent_remark: data.ic_amendent_remark,
      ic_is_size_analysis: data.ic_is_size_analysis?.[0] || false,
      ic_size_analysis_data: subTableData,
      ic_is_account_of: data.ic_is_account_of === "Yes",
      ic_cert_config_data,
      ic_is_cert_config_data: data.ic_is_cert_config_data?.[0] || false,
      type_of_amnendment: data.type_of_amnendment || 'Certificate',
      ic_amendent_remark_tm: data.ic_amendent_remark_tm,
      ic_as_per_client_name: data.ic_as_per_client_name,
      status,
      is_testreport_completed: true,
      is_sfm_completed: true
    },
  };

  setIsOverlayLoader(true);

  try {
    let res;

    if (data.ic_id) {
      payload.ic_id = data.ic_id;
      const actualpayload = {
        ic_id: data.ic_id,
        ic_data: {
          is_amendment_change: true,
          ic_amendent_data_json: payload.ic_data,
          ic_is_amendent_report: true,
          status: mainStatus
        }
      }
      if (['SU'].includes(getCurrentRole())) {
        delete actualpayload.ic_data.status
      }
      res = await putDataFromApi(
        InternalCertificateUpdateApi,
        actualpayload
      );
    }

    if (res?.data?.status === 200) {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 2000,
        theme: "light",
      });

      setTimeout(() => {
        navigate("/testReport");
      }, 1000);
    } else {
      toast.error(res?.message || "Something went wrong", {
        position: "top-right",
        autoClose: 2000,
        theme: "light",
      });
    }
  } catch (error) {
    console.log('rrr', error)
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 2000,
      theme: "light",
    });
  } finally {
    setIsOverlayLoader(false);
  }
};

export const changeTestReportAmendentStatusChange = async (
  ic_id,
  navigate,
  status,
  remarkText = "",
  setIsOverlayLoader,
  formData
) => {
  if (status === "tm-approved") {
    status = "publish"
  }
  try {
    let ic_data = {
      status: status
    };
    if (status === "dtm-reject" || status === "tm-reject") {
      ic_data.ic_rejection_remark = remarkText;
    }
    let actualpayload = {
      ic_id: ic_id,
      ic_data: {
        ic_amendent_data_json: {
          ...formData[0].ic_amendent_data_json,
          ...ic_data
        },
        is_amendment_change: true
      }
    }
    if (status === "dtm-reject" || status === "tm-reject") {
      actualpayload = {
        ...actualpayload,
        ic_data: {
          ...actualpayload.ic_data,
          status: "amendment reject",
        }
      }
    }
    if (status === "publish") {
      actualpayload = {
        ...actualpayload,
        ic_data: {
          ...actualpayload.ic_data,
          status: "amended"
        },
      }
    }
    setIsOverlayLoader(true);
    let res = await putDataFromApi(InternalCertificateUpdateApi, actualpayload);
    if (res?.data?.status === 200) {
      toast.success(res?.data?.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      navigate("/testReport");
    } else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  } catch (error) {
    toast.error("Something went wrong", {
      position: "top-right",
      autoClose: 2000,
      theme: "light",
    });
  } finally {
    setIsOverlayLoader(false);
  }
};
export const handleAmendmentInitiateAmendement = async (ic_id, setIsOverlayLoader, setIsCustomPopupModal, getAllListingData, formData) => {
  try {
    setIsOverlayLoader(true)
    const bodyToPass = {
      ic_id: ic_id,
    };
    let res = await postDataFromApi(InternalCertificateGetApi, bodyToPass);
    if (res?.data?.status === 200) {
      let responseData = res.data.data;
      responseData.ic_smpldrawnbylab = responseData.ic_smpldrawnbylab
        ? "Sample Drawn By Laboratory"
        : responseData.ic_is_client_req ? "As Per Client" : "Sample Not Drawn By Laboratory";
      responseData.ic_dos = responseData.ic_dos ? responseData.ic_dos : "N/A";
      responseData.ic_ambienttemp = responseData.ic_ambienttemp
        ? responseData.ic_ambienttemp.replace(
          new RegExp(`\\s*°C\\s*`, "gi"),
          ""
        )
        : "";
      responseData.ic_humidity = responseData.ic_humidity
        ? responseData.ic_humidity.replace(new RegExp(`\\s*%\\s*`, "gi"), "")
        : "";
      responseData.ic_borometric_pressure = responseData.ic_borometric_pressure
        ? responseData.ic_borometric_pressure.replace(
          new RegExp(`\\s*hPa\\s*`, "gi"),
          ""
        )
        : "";
      responseData.ic_rejection_remark = responseData.ic_rejection_remark
        ? responseData.ic_rejection_remark
        : "-";

      responseData.company_code = responseData.company.company_code;
      responseData.cmd_id = responseData.commodity.commodity_id;
      responseData.lab_id = responseData.fk_lab_id;
      responseData.ic_is_size_analysis = Array.isArray(responseData.ic_is_size_analysis) ? responseData.ic_is_size_analysis : responseData.ic_is_size_analysis ? [responseData.ic_is_size_analysis] : [];
      responseData.ic_is_cert_config_data = Array.isArray(responseData.ic_is_cert_config_data) ? responseData.ic_is_cert_config_data : responseData.ic_is_cert_config_data ? [responseData.ic_is_cert_config_data] : [];
      responseData.ic_is_account_of = responseData.ic_is_account_of ? "Yes" : "No";
      responseData.ic_customername_2 = responseData.ic_customername
      responseData.ic_customeraddress_2 = responseData.ic_customeraddress
      const data = responseData
      const payload = {
        ic_data: {
          ic_ulrno: '',
          ic_refenence: data.ic_refenence,
          ic_discipline: data.ic_discipline,
          ic_group: data.ic_group,
          ic_customername: data.ic_customername,
          ic_customeraddress: data.ic_customeraddress,

          ic_smpldrawnbylab:
            data.ic_smpldrawnbylab === "Sample Drawn By Laboratory",

          ic_is_client_req: ![
            "Sample Drawn By Laboratory",
            "Sample Not Drawn By Laboratory",
          ].includes(data.ic_smpldrawnbylab),

          ic_descofsmpl: data.ic_descofsmpl,
          ic_locationofsmpl: data.ic_locationofsmpl,
          ic_dos: data.ic_dos === "N/A" ? null : data.ic_dos,
          ic_samplingmethods: data.ic_samplingmethods,
          ic_envcondition: data.ic_envcondition,
          ic_mark_from: data.ic_mark_from,
          ic_mark_to: data.ic_mark_to,
          ic_seal_from: data.ic_seal_from,
          ic_seal_to: data.ic_seal_to,
          ic_conditionofsmpl: data.ic_conditionofsmpl,
          ic_dateofrecsmpl: data.ic_dateofrecsmpl,
          ic_dateofanalysis: data.ic_dateofanalysis,
          ic_noofsmpls: data.ic_noofsmpls,
          ic_ambienttemp: data.ic_ambienttemp,
          ic_humidity: data.ic_humidity,
          ic_borometric_pressure: data.ic_borometric_pressure,
          ic_remarks: data.ic_remarks,

          ic_is_mark: !!data.ic_is_mark,
          ic_is_seal: !!data.ic_is_seal,
          ic_dateanalysiscompleted: data.ic_dateanalysiscompleted,
          ic_reference_date: data.ic_reference_date,
          ic_test_performed_at: data.ic_test_performed_at,

          ic_is_dos: !!data.ic_is_dos,
          ic_is_samplingmethods: !!data.ic_is_samplingmethods,
          ic_is_locationofsmpl: !!data.ic_is_locationofsmpl,
          ic_is_envcondition: !!data.ic_is_envcondition,
          ic_is_conditionofsmpl: !!data.ic_is_conditionofsmpl,

          ic_mark_and_seal_qualifier: data.ic_mark_and_seal_qualifier,
          ic_test_report_no: data.ic_test_report_no,
          ic_is_2sign_format: data.ic_is_2sign_format || false,
          ic_lab_address: data.ic_lab_address,
          ic_amendent_remark: data.ic_amendent_remark,
          ic_is_size_analysis: data.ic_is_size_analysis?.[0] || false,
          ic_size_analysis_data: responseData.ic_size_analysis_data,
          ic_is_account_of: data.ic_is_account_of === "Yes",
          ic_cert_config_data: data.ic_cert_config_data,
          ic_is_cert_config_data: data.ic_is_cert_config_data?.[0] || false,
          type_of_amnendment: formData[0]?.type_of_amnendment || 'Certificate',
          ic_amendent_remark_tm: formData[0]?.ic_amendent_remark_tm,
          ic_as_per_client_name: formData[0]?.ic_as_per_client_name,
          status: "saved",
        },
      };
      const actualpayload = {
        ic_id: data.ic_id,
        ic_data: {
          is_amendment_change: true,
          ic_amendent_data_json: payload.ic_data,
          ic_is_amendent_report: true,
          status: "amendment initiated",
        }
      }
      let res2 = await putDataFromApi(InternalCertificateUpdateApi, actualpayload);
      if (res2?.data?.status === 200) {
        toast.success(res2?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        getAllListingData()

      } else {
        toast.error(res2.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
    else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }
  catch (ex) {
    console.log(ex)
  }
  finally {
    setIsCustomPopupModal(false)
    setIsOverlayLoader(false)
  }
}
export const handleSFMFinalPostWithAmendementBKP = async (setIsOverlayLoader, navigate) => {
  try {
    setIsOverlayLoader(true)
    const hash = window.location.hash;
    const params = new URLSearchParams(hash.split("?")[1]);
    const ic_id = decryptDataForURL(params.get("ic_id"))
    const bodyToPass = {
      ic_id: ic_id,
    };
    let res = await postDataFromApi(InternalCertificateGetApi, bodyToPass);
    if (res?.data?.status === 200) {
      let responseData = res.data.data;
      let ic_jsondata = responseData.ic_amendent_data_json
      ic_jsondata = {
        ...ic_jsondata,
        status: 'pending'
      }
      let actualpayload = {
        ic_id: ic_id,
        ic_data: {
          ic_amendent_data_json: ic_jsondata,
          status: "amendment in-process"
        }
      }
      let res2 = await putDataFromApi(InternalCertificateUpdateApi, actualpayload);
      if (res2?.data?.status === 200) {
        toast.success(res2?.data?.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/testReport");
      } else {
        toast.error(res2.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    }
    else {
      toast.error(res.message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }
  catch (ex) {
    console.log(ex)
  }
  finally {
    setIsOverlayLoader(false)
  }
}

export const handleSFMFinalPostWithAmendement = async (setIsOverlayLoader, formData, status, main_status, callBack, is_sfm_completed) => {
  try {
    setIsOverlayLoader(true)
    let ic_data = formData[0]?.ic_data
    const ic_id = ic_data?.ic_id
    let ic_jsondata = ic_data.ic_amendent_data_json
    if (main_status === "amendment in-process") {
      ic_jsondata.ic_dateanalysiscompleted = moment(new Date()).format("yyyy-MM-DD")
    }
    ic_jsondata = {
      ...ic_jsondata,
      status: status,
      is_sfm_completed: is_sfm_completed
    }
    let actualpayload = {
      ic_id: ic_id,
      ic_data: {
        ic_amendent_data_json: ic_jsondata,
        status: main_status
      },
      is_amendment: true
    }
    let res2 = await putDataFromApi(InternalCertificateUpdateApi, actualpayload);
    if (res2?.data?.status === 200) {
      callBack()
    }
  }
  catch (ex) {
    console.log(ex)
  }
  finally {
    setIsOverlayLoader(false)
  }
}